import { render, staticRenderFns } from "./ListTeamItem.vue?vue&type=template&id=31e93760&scoped=true"
import script from "./ListTeamItem.vue?vue&type=script&lang=ts"
export * from "./ListTeamItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e93760",
  null
  
)

export default component.exports